module.exports = __webpack_public_path__ + "static/media/2020-nov-1.c4aa7e93.jpeg";